if (!customElements.get('sticky-product-form')) {
  customElements.define(
    'sticky-product-form',
    class StickyProductForm extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.formId;
        this.submitButton = this.querySelector('.sticky-product-form__submit');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.spinner = this.querySelector('.loading__spinner');
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleSubmitEnd = this.handleSubmitEnd.bind(this);
      }

      connectedCallback() {
        this.form = document.getElementById(this.formId);
        if (this.form) this.observeFormVisibility();

        this.setupQuantitySync();
        this.syncSubmitButtonFromMain();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleSubmitEnd);
        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, this.handleSubmitEnd);
        document.addEventListener('submit', this.handleFormSubmit);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
        this.cartErrorUnsubscriber?.();
        document.removeEventListener('submit', this.handleFormSubmit);
      }

      observeFormVisibility() {
        this.observer = new IntersectionObserver(
          (entries) => {
            const formIsVisible = entries[0].isIntersecting;
            this.classList.toggle('sticky-product-form--visible', !formIsVisible);
            this.setAttribute('aria-hidden', formIsVisible);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.form);
      }

      setupQuantitySync() {
        const stickyInput = this.querySelector('.sticky-product-form__quantity-input input');
        if (!stickyInput) return;

        const mainInput = document.getElementById(`Quantity-${this.sectionId}`);
        if (!mainInput) return;

        const syncFromMain = () => {
          stickyInput.value = mainInput.value;
        };
        const syncToMain = () => {
          if (mainInput.value === stickyInput.value) return;
          mainInput.value = stickyInput.value;
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        };

        syncFromMain();
        mainInput.addEventListener('change', syncFromMain);
        stickyInput.addEventListener('change', syncToMain);
      }

      handleFormSubmit(event) {
        if (event.target !== this.form) return;
        this.submitButton?.classList.add('loading');
        this.submitButton?.setAttribute('aria-disabled', 'true');
        this.spinner?.classList.remove('hidden');
      }

      handleSubmitEnd() {
        this.submitButton?.classList.remove('loading');
        this.submitButton?.removeAttribute('aria-disabled');
        this.spinner?.classList.add('hidden');
      }

      handleVariantChange({ data: { sectionId, html, variant } }) {
        if (sectionId !== this.sectionId) return;

        this.updateFromHtml(html, `StickyProductPrice-${sectionId}`);
        this.updateVariantLabel(variant);
        this.syncSubmitButtonFromMain();
        this.updateImage(variant);
      }

      updateFromHtml(html, id) {
        const source = html.getElementById(id);
        const destination = this.querySelector(`#${id}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
      }

      updateVariantLabel(variant) {
        const label = this.querySelector(`#StickyProductVariant-${this.sectionId}`);
        if (label && variant) label.textContent = variant.title;
      }

      // Mirrors the main Add to Cart button's live text/disabled state instead of
      // re-translating, so the sticky button always matches it in any language.
      syncSubmitButtonFromMain() {
        if (!this.submitButton) return;
        const mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!mainButton) return;

        const mainText = mainButton.querySelector('span')?.textContent;
        if (mainText && this.submitButtonText) this.submitButtonText.textContent = mainText;
        this.submitButton.toggleAttribute('disabled', mainButton.disabled);
      }

      updateImage(variant) {
        const image = this.querySelector(`#StickyProductImage-${this.sectionId}`);
        const src = variant?.featured_image?.src;
        if (image && src) image.src = `${src}${src.includes('?') ? '&' : '?'}width=160`;
      }
    }
  );
}
